import { EnrollmentConfigState } from "@pages/Contents/V2/Corporate/Catalog/Enrollment/types";
import { buildInitialConfig } from "@pages/Contents/V2/Corporate/Catalog/Enrollment/config/enrollmentFieldsConfig";

export interface GroupLoSelection {
  id: number;
  type: string;
}

export interface StaticGroupWizardData {
  name: string;
  description: string;
  userIds: number[];
  loSelections: GroupLoSelection[];
  enrollConfig: EnrollmentConfigState;
}

export const buildInitialEnrollConfig = (): EnrollmentConfigState => ({
  ...buildInitialConfig(),
  enrollType: "TOP",
});

export const INITIAL_GROUP_WIZARD_DATA: StaticGroupWizardData = {
  name: "",
  description: "",
  userIds: [],
  loSelections: [],
  enrollConfig: buildInitialEnrollConfig(),
};
